module.exports = __webpack_public_path__ + "img/si.9e0e66b4.svg";